import { z } from "zod";

/* API(/api-proxy) 에러 응답 스키마 */
export const ApiErrorSchema = z.object({
  errorCode: z.string(),
  message: z.string(),
});

export type ApiErrorType = z.infer<typeof ApiErrorSchema>;

/* community API 에러 응답 스키마 */
export const CommunityApiErrorSchema = z.object({
  result: z.object({
    timestamp: z.number(),
    path: z.string(),
    status: z.number(),
    error: z.string(),
    requestId: z.string(),
    trace: z.string(),
    exceptionClassName: z.string(),
    message: z.string(),
    displayableMessage: z.string(),
  }),
});

export type CommunityApiErrorType = z.infer<typeof CommunityApiErrorSchema>;

/* conti API 에러 응답 스키마 */
export const ContiApiErrorSchema = z.object({
  error: z.string(),
  path: z.string(),
  status: z.number(),
  timestamp: z.number(),
});

export type ContiApiErrorType = z.infer<typeof ContiApiErrorSchema>;
